<template>
    <div>
        <head-layout
            :title="`Account Form for ${$page.props.accountForm.company_name}`"
        />

        <v-row class="secondary--text">
            <v-col cols="12">
                <inertia-link
                    :href="route('manage.account-forms.index')"
                    class="text-subtitle-1 my-4"
                >
                    &lArr; Back to Account Forms
                </inertia-link>

                <div class="text-h4">View Account Form</div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6" class="text-right">
                <v-btn
                    target="_blank"
                    :href="`https://kingsr.current-rms.com/members/${$page.props.accountForm.member_id}`"
                    >Open In Current</v-btn
                >
            </v-col>
            <v-col cols="12" md="6" order-md="first">
                <div class="text-subtitle-1 mt-4">
                    <span v-text="$page.props.accountForm.company_name" />
                    <v-chip
                        v-if="$page.props.accountForm.credit_approved_at"
                        small
                        class="mx-2"
                        color="primary"
                    >
                        Credit Approved
                    </v-chip>
                </div>
            </v-col>
        </v-row>

        <v-row
            v-if="
                $page.props.accountForm.credit_required &&
                !$page.props.accountForm.credit_approved_at
            "
        >
            <v-col>
                <v-form @submit.prevent="approveCredit">
                    <form-section
                        color="primary lighten-4"
                        title="Approve the credit account"
                    >
                        <text-field
                            label="Monthly Credit Amount"
                            required
                            :rules="[requiredRule('Credit Amount')]"
                            v-model="creditForm.amount"
                            type="number"
                            prepend-icon="mdi-currency-gbp"
                        />
                        <v-btn
                            type="submit"
                            color="primary"
                            :loading="creditForm.processing"
                        >
                            Approve
                        </v-btn>
                    </form-section>
                </v-form>
            </v-col>
        </v-row>

        <account-form-fields v-model="$page.props.accountForm" view-only />
    </div>
</template>

<script>
import HeadLayout from "../../Layouts/HeadLayout";
import AccountFormFields from "../../Components/AccountForm/AccountFormFields";
import FormSection from "../../Components/Forms/FormSection";
import ValidationRules from "../../Mixins/ValidationRules";
import TextField from "../../Components/Forms/TextField";

export default {
    name: "AccountFormShow",
    components: { TextField, FormSection, AccountFormFields, HeadLayout },
    mixins: [ValidationRules],

    data() {
        return {
            creditForm: this.$inertia.form({
                amount: this.$page.props.accountForm.credit_amount,
            }),
            success: false,
        };
    },

    methods: {
        approveCredit() {
            this.creditForm.put(
                this.route(
                    "manage.account-forms.approve-credit",
                    this.$page.props.accountForm.uuid
                ),
                {
                    onSuccess: () => {
                        this.success = true;
                    },
                }
            );
        },
    },
};
</script>

<style scoped></style>
